import PropTypes from 'prop-types';
import styles from './Loader.module.css';

const Loader = ({ show = false, label = 'Loading' }) => {
  if (!show) return null;

  return (
    <div className={styles.backdrop} aria-busy="true" aria-live="polite">
      <div className={styles.dotSpinner} role="status" aria-label={label}>
        <div className={styles.dotSpinnerDot} />
        <div className={styles.dotSpinnerDot} />
        <div className={styles.dotSpinnerDot} />
        <div className={styles.dotSpinnerDot} />
        <div className={styles.dotSpinnerDot} />
        <div className={styles.dotSpinnerDot} />
        <div className={styles.dotSpinnerDot} />
        <div className={styles.dotSpinnerDot} />
      </div>
    </div>
  );
};

Loader.propTypes = {
  show: PropTypes.bool,
  label: PropTypes.string,
};

export default Loader;
